import { createSelector } from 'reselect'

const select = (state) => state.devices

const selectAllDevices = createSelector(select, (devices) => devices.devices)

const excludeGeneral = (devices) =>
  devices.filter(
    (device) =>
      !device.manufacturer.match(/general/i) && !device.name.match(/general/i)
  )

const excludeFreeNav = (devices) =>
  devices.filter((device) => !/freenav/.test(device.customerID))

const selectDevices = createSelector(selectAllDevices, (devices) =>
  excludeGeneral(excludeFreeNav(devices))
)

const selectDevicesFetching = createSelector(
  select,
  (devices) => devices.isFetching
)

export { selectDevices, selectDevicesFetching, selectAllDevices }
